import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import * as SecureStorage from 'secure-web-storage';

@Injectable({
  providedIn: 'root'
})
export class CryptUtilService {

  public lsSecureStorage = new SecureStorage(localStorage, {
    hash(key) {
      key = CryptoJS.SHA256(key, 'Secure salt that keeps the info safe');

      return key.toString();
    },
    encrypt(data) {
      data = CryptoJS.AES.encrypt(data, 'Secure salt that keeps the info safe');

      data = data.toString();

      return data;
    },
    decrypt(data) {
      data = CryptoJS.AES.decrypt(data, 'Secure salt that keeps the info safe');

      data = data.toString(CryptoJS.enc.Utf8);

      return data;
    }
  });

  public ssSecureStorage = new SecureStorage(sessionStorage, {
    hash(key) {
      key = CryptoJS.SHA256(key, 'Secure salt that keeps the info safe');

      return key.toString();
    },
    encrypt(data) {
      data = CryptoJS.AES.encrypt(data, 'Secure salt that keeps the info safe');

      data = data.toString();

      return data;
    },
    decrypt(data) {
      data = CryptoJS.AES.decrypt(data, 'Secure salt that keeps the info safe');

      data = data.toString(CryptoJS.enc.Utf8);

      return data;
    }
  });

  // Keys that should always use sessionStorage to avoid conflicts across browser tabs
  // (e.g., when master and release projects are opened in different tabs)
  // IMPORTANT: Must be declared BEFORE sessionIds to ensure proper initialization order
  private sessionStorageOverrideKeys: string[] = ['isMasterProject'];

  sessionIds: string[] = this.getItem('sessionIds', 'SESSION') || [];

  constructor() { }

  private getEffectiveStorageOption(key: string, storageOption: string): string {
    // Force SESSION storage for specific keys to prevent cross-tab conflicts
    if (this.sessionStorageOverrideKeys?.includes(key)) {
      return 'SESSION';
    }
    return storageOption;
  }

  setItem(key, value, storageOption) {
    const effectiveStorage = this.getEffectiveStorageOption(key, storageOption);
    this.removeItem(key, effectiveStorage);
    if (effectiveStorage == 'LOCAL') {
      this.lsSecureStorage.setItem(key, value);
    } else {
      if (this.sessionIds.find(t => key == t) == undefined) {
        this.sessionIds.push(key);
        this.ssSecureStorage.setItem('sessionIds', this.sessionIds);
      }
      this.ssSecureStorage.setItem(key, value);
    }
  }

  getItem(key, storageOption) {
    const effectiveStorage = this.getEffectiveStorageOption(key, storageOption);
    if (effectiveStorage == 'LOCAL') {
      return this.lsSecureStorage.getItem(key);
    } else {
      return this.ssSecureStorage.getItem(key);
    }
  }

  removeItem(item, storageOption) {
    const effectiveStorage = this.getEffectiveStorageOption(item, storageOption);
    if (effectiveStorage == 'LOCAL') {
      this.lsSecureStorage.removeItem(item);
    } else {
      this.ssSecureStorage.removeItem(item);
    }
  }

  sessionClear() {
    if (this.sessionIds.length > 0) {
      for (let i of this.sessionIds) {
        this.ssSecureStorage.removeItem(i);
      }
      this.removeItem('sessionIds', 'SESSION');
    }
  }

  encryptObject(obj: any): string {
    const jsonString = JSON.stringify(obj);
    const encrypted = CryptoJS.AES.encrypt(jsonString, 'Secure salt that keeps the info safe').toString();
    return encrypted;
  }

  decryptObject(encryptedString: string): any {
    const bytes = CryptoJS.AES.decrypt(encryptedString, 'Secure salt that keeps the info safe');
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedString);
  }


  // makeid(length) {
  //   let result = '';
  //   let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  //   let charactersLength = characters.length;
  //   for (let i = 0; i < length; i++) {
  //     result += characters.charAt(Math.floor(Math.random() * charactersLength));
  //   }
  //   return result;
  // }
}
